import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SetCanSaveEditOrder } from "../../../../../../Redux/actions/actionNames";

const App = () => {
  const dispatch = useDispatch();

  // ====== معادل mapStateToProps ======
  const price = useSelector((state) => state.NewOrder.newOrder.price);
  const pickup = useSelector((state) => state.EditOrder.editOrder.pickup);

  const orderCustomFieldDefinitions = useSelector(
    (state) => state.ViewTravel.pureData?.customFieldDefinitions
  );

  const pickupCustomFields = useSelector(
    (state) => state.EditOrder.editOrder.pickup.customField
  );

  const deliveryMethodSetting = useSelector(
    (state) => state.ViewTravel.pureData.deliveryMethod?.setting
  );

  // ====== Helpers ======

  const emailValidate = useCallback((email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }, []);

  const pickupRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    let boollx = true;

    orderCustomFieldDefinitions
      ?.filter((item) => item.stage === "pickup" && item.isRequired)
      .forEach((item) => {
        if (!pickupCustomFields?.[item.key]) {
          boollx = false;
        }
      });

    const name = deliveryMethodSetting.isPickupAddressNameRequired
      ? pickup.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isPickupAddressPhoneRequired
      ? pickup.phone?.trim()?.length > 3
      : true;

    const email = deliveryMethodSetting.isPickupAddressEmailRequired
      ? pickup.email &&
        pickup.email.length > 0 &&
        emailValidate(pickup.email)
      : true;

    return name && phone && email && boollx;
  }, [
    deliveryMethodSetting,
    orderCustomFieldDefinitions,
    pickupCustomFields,
    pickup,
    emailValidate,
  ]);

  // ====== معادل componentWillReceiveProps ======
  useEffect(() => {
    const canSave = price?.done && pickupRequiredCheck();

    dispatch(SetCanSaveEditOrder(!!canSave));
  }, [price, pickupRequiredCheck, dispatch]);

  return null;
};

export default App;
